import * as types from "../../../actions/actionTypes";

const initialState = {
  loading: true,
  error: "",
  data: []
};

const PettyCashierMonthlyBudgetReview = (state = initialState, action) => {
  switch (action.type) {
    case types.PETTY_CASHIER_GET_MONTHLY_REVIEW_BUDGET_REQUEST:
      return { ...state, loading: true, error: "", data: [] };
    case types.PETTY_CASHIER_GET_MONTHLY_REVIEW_BUDGET_SUCCESS:
      return {
        ...state,
        data: action.payLoad,
        loading: false,
      };
    case types.PETTY_CASHIER_GET_MONTHLY_REVIEW_BUDGET_FAILURE:
      return { ...state, loading: false, error: action.error };

    default:
      return state;
  }
};

export default PettyCashierMonthlyBudgetReview;
